export default [
  {
    path: "/media",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "@/Modules/Media/Views/Home.vue")
  }
]
